export default __webpack_public_path__ + "static/media/ExclusivoOpen.c70a3ca4.jpg";